import { render, staticRenderFns } from "./index.vue?vue&type=template&id=54c8d17a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=54c8d17a&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=54c8d17a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Users/zhc/Documents/CF40/CF40-Java/cf40_pc_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c8d17a",
  null
  
)

export default component.exports